export default "__VITE_ASSET__5df0955a__"